import React from 'react';
import './KpiCard.css';

/**
 * KPI カード（SCR-P-001 DP-P-001〜004。コンポーネント対応表 §4.2）
 *
 * 大きな数字の下に前期比（C10）を出す。色だけに頼らないよう、印（▲▼）と読み上げの文を持つ（§7.2）。
 *
 * @param {object} props
 * @param {string} props.title - 「面談件数」等
 * @param {string} props.value - 書式を整えた値（「42」「7.1%」「N/A」）
 * @param {string} [props.valueSuffix] - 値の後ろの小さな単位（「件」）
 * @param {string} [props.valuePrefix] - 値の前の小さな文字（「エージェント」）
 * @param {{text: string, spokenText: string, tone: string}} props.change - formatChange の結果
 * @param {string} [props.note] - 値の下の補足（「対象の面談 20 件」「対象期間に面談がありません」）
 */
function KpiCard({ title, value, valueSuffix, valuePrefix, change, note }) {
    const spoken = [title, `${valuePrefix ? `${valuePrefix} ` : ''}${value}${valueSuffix || ''}`, change.spokenText, note]
        .filter(Boolean)
        .join('、');

    return (
        <div className="kpi-card" role="group" aria-label={spoken} tabIndex={0}>
            <div className="kpi-card-title" aria-hidden="true">{title}</div>
            <div className="kpi-card-value" aria-hidden="true">
                {valuePrefix && <span className="kpi-card-value-prefix">{valuePrefix}</span>}
                <span className="kpi-card-value-number">{value}</span>
                {valueSuffix && <span className="kpi-card-value-suffix">{valueSuffix}</span>}
            </div>
            <div className={`kpi-card-change kpi-card-change--${change.tone}`} aria-hidden="true">
                {change.text}
            </div>
            {note && <div className="kpi-card-note" aria-hidden="true">{note}</div>}
        </div>
    );
}

export default KpiCard;
